import { IconButton } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useEffect, useState } from 'react';

export interface FieldLockProps {
    onChange: (locked: boolean) => void;
    labelId: string;
    disabled: boolean;
    displayed: boolean;
    value: boolean;
    size?: number;
}

const FieldLock = (props: FieldLockProps): JSX.Element => {
    const [locked, setLocked] = useState(props.value);

    useEffect(() => {
        setLocked(props.value);
    }, [props.value]);

    const handleClick = () => {
        const newLocked = !locked;
        setLocked(newLocked);
        props.onChange(newLocked);
    };

    const fontSize = props.size ? `${props.size}px` : '14px';

    return props.displayed ? (
        <IconButton
            onClick={handleClick}
            aria-label={`lock${props.labelId}`}
            disabled={props.disabled}
            size="small"
        >
            {locked ? <LockIcon sx={{ fontSize: fontSize }} /> : <LockOpenIcon sx={{ fontSize: fontSize }} />}
        </IconButton>
    ) : (<></>) ;
  };

export default FieldLock;